import axios from '../utils/AxiosInstance'

export default {
  // namespaced: true,
  state: {
    sessions: {
      selectIds: [],
      filters: {},
      paginate: {},
      selectId: false
    }
  },
  mutations: {
    SET_SESSION_SELECT_IDS (store, ids) {
      store.sessions.selectIds = ids
    },
    REMOVE_SESSION_SELECT_IDS (store, ids) {
      store.sessions.selectIds = store.sessions.selectIds.filter((v) => { return !ids.includes(v) })
    },
    SET_SESSION_SELECT_ID (store, id) {
      store.sessions.selectId = id
    },
    SET_SESSION_FILTERS (store, filters) {
      store.sessions.filters = filters
    },
    SET_SESSION_PAGINATE (store, val) {
      store.sessions.paginate = {
        limit: val.limit,
        page: val.page,
        pages: val.pages,
        total: val.total
      }
    }
  },
  getters: {
    getSessions: (store, getters) => {
      return store.sessions.selectIds.map((id) => {
        return getters['entities/sessions/find'](id)
      })
    },
    getSessionsFilters: (store, getters) => {
      return store.sessions.filters
    },
    getSessionsPaginate: (store, getters) => {
      return store.sessions.paginate
    },
    getSession: (store, getters) => {
      return getters['entities/sessions/find'](store.sessions.selectId) || {}
    }
  },
  actions: {
    /*
    selectSessions
    */
    selectSessions ({commit, dispatch, getters, state}, filters) {
      return dispatch('getSessions', filters)
      .then((response) => {
        commit('SET_SESSION_FILTERS', filters)
        commit('SET_SESSION_PAGINATE', response)
        commit('SET_SESSION_SELECT_IDS', response.docs.map((item) => { return item._id }))
        return response
      })
    },
    /*
    refreshSelectSessions
    */
    refreshSelectSessions ({commit, dispatch, getters, state}) {
      return dispatch('selectSessions', getters.getSessionsFilters)
    },
    /*
    selectSession
    */
    selectSession ({commit, dispatch, getters, state}, id) {
      return dispatch('getSessionById', id)
      .then((response) => {
        commit('SET_SESSION_SELECT_ID', response._id)
        return response
      })
    },
    /*
    getSessions
    */
    getSessions ({commit, dispatch, getters, state}, filters) {
      return axios
      .get(`/accounts/${getters.getAccount._id}/sessions`, {params: filters})
      .then((response) => {
        return dispatch('entities/sessions/insert', {
          data: response.data.docs
        })
        .then((result) => {
          return {
            docs: result.sessions || [],
            limit: response.data.limit,
            page: response.data.page,
            pages: response.data.pages,
            total: response.data.total
          }
        })
      })
    },
    /*
    getSessionById
    */
    getSessionById ({commit, dispatch, getters, state}, id) {
      return axios
      .get(`/accounts/${getters.getAccount._id}/sessions/${id}`)
      .then((response) => {
        return dispatch('entities/sessions/insert', {
          data: response.data
        })
      })
      .then((result) => {
        return result.sessions[0]
      })
    },
    /*
    deleteSession
    */
    deleteSession ({commit, dispatch, getters, state}, id) {
      return axios
      .delete(`/accounts/${getters.getAccount._id}/sessions/${id}`)
      .then((response) => {
        commit('REMOVE_SESSION_SELECT_IDS', [id])
        dispatch('entities/sessions/delete', id)
        return {}
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/Session.js